import React from "react";
import { Navigate, Routes } from "react-router-dom";

import { Route } from "src/shared/components";
import {
  BadgeRoute,
  Route as RouteConstants,
} from "src/shared/constants/route";
import { NetworkingContextProvider } from "src/shared/contexts";
import { Permission } from "src/shared/contexts/PermissionsContext/types";
import NotFound from "src/views/404";
import BadgePage from "src/views/hacker/rsvp/badge";

import BadgeConnect from "./connect";
import BadgeSync from "./sync";

export const BadgeRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<Navigate to={RouteConstants.BADGE_MY_BADGE} replace />}
    />
    <Route
      path={BadgeRoute.MY_BADGE}
      element={
        <NetworkingContextProvider>
          <BadgePage variant="dashboard" />
        </NetworkingContextProvider>
      }
    />
    <Route path={BadgeRoute.CONNECT} element={<BadgeConnect />} requireAuth />
    <Route path={BadgeRoute.SYNC} element={<BadgeSync />} requireAuth />
    <Route
      path={BadgeRoute.ADMIN_SYNC}
      element={<BadgeSync admin />}
      requirePermissions={[Permission.ORGANIZER]}
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);
